import EmptyResults from 'components/EmptyResults'
import { Button, Container, Icon, List, Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Referral/List/subcomponents/List/referral-list.module.scss'
import { useTableConfig } from 'modules/Referral/List/subcomponents/List/hooks/useTableConfig'
import GridSpinner from 'components/UI/GridSpinner'

const ReferralList = ({ className, onChangePage, data, loading, pagination }) => {
  const { t } = useTranslation()

  const { tableState, tableConfig } = useTableConfig({}, data)

  return (
    <div className={className}>
      <List
        Loader={() => <GridSpinner width={24} />}
        loading={loading}
        table={tableState}
        config={tableConfig}
        EmptyComponent={() =>
          !loading && data.length === 0 ? (
            <EmptyResults
              className={styles['referral-list__empty']}
              header={t('referral::empty_list_header')}
              text={t('referral::empty_list')}
            />
          ) : (
            <GridSpinner />
          )
        }
      />
      {data.length > 0 && (
        <div className={styles['pagination']}>
          {!!pagination.total && (
            <span className={styles['pagination__from-to']}>
              {data.length === 0 ? 0 : 1}
              {' – '}
              {data.length}{' '}
              <span className={styles['pagination__from-text']}>{t('common::pagination.of')}</span>{' '}
              {pagination.total}
            </span>
          )}
          <Container
            display={'flex'}
            flexAlign={'center'}
            flexJustify={'center'}
            className={styles['show-more__container']}
          >
            {pagination.total !== data.length && (
              <Button
                onClick={() => onChangePage(1)}
                className={styles['show-more__button']}
                variant={'link'}
                color={'Label-GU-Primary'}
                endIcon={
                  loading ? (
                    <Spinner width={16} color={'inherit'} />
                  ) : (
                    <Icon name={'arrow1-down'} color={'inherit'} size={'s'} />
                  )
                }
              >
                {t('common::pagination.show_more')}
              </Button>
            )}
          </Container>
        </div>
      )}
    </div>
  )
}

ReferralList.propTypes = {
  className: PropTypes.string,
  onChangePage: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  pagination: PropTypes.object,
}

export default ReferralList
